const DEFAULT_SALE_MULTIPLIER = 1;

export function resolveSaleMultiplier(saleMultiplier?: number | null): number {
	if (saleMultiplier == null || saleMultiplier <= 0) {
		return DEFAULT_SALE_MULTIPLIER;
	}

	return saleMultiplier;
}
